import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { NavigationManagerService } from '../../services/platform/ionic/navigation-manager.service';
import { RoutesEnum } from '../../shared/enum/routes.enum';

/**
 * Redirige al kiosk si la vista no ha recibido el parámetro (p. ej. al refrescar)
 *
 */
export const requiredParamGuard = (key: string): CanActivateFn => (_, state) => {
  const navigationManager = inject(NavigationManagerService);

  if (navigationManager.hasParam(state.url, key)) {
    return true;
  }

  navigationManager.navigateRoot(RoutesEnum.kiosk, false);
  return false;
};
